module.exports = __webpack_public_path__ + "img/video_img.9c62b5e5.svg";